export default __webpack_public_path__ + "static/media/legsize.99f4954c.svg";